import { render, staticRenderFns } from "./CountryTemplates.vue?vue&type=template&id=33bcdbf2&"
import script from "./CountryTemplates.vue?vue&type=script&lang=js&"
export * from "./CountryTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports